import React from 'react';

import './ContactForm.css';

const ContactForm = () => (
  <form
    className="contact-form"
    method="POST"
    action="https://formspree.io/f/spdaltonjr@gmail.com"
  >
    <div className="form-field">
      <label htmlFor="name">
        <div className="label-content">Your Name:</div>
        <input type="text" name="name" required />
      </label>
    </div>

    <div className="form-field">
      <label htmlFor="email">
        <div className="label-content">Your Email:</div>
        <input type="email" name="email" required />
      </label>
    </div>

    <div className="form-field">
      <label htmlFor="message">
        <div className="label-content">Message:</div>
        <textarea className="stretch" name="message" rows="5" required />
      </label>
    </div>

    <button type="submit">Send</button>

    <div>
      {window.location.hash === '#success' && (
        <div id="success">
          <p>Your message has been sent!</p>
        </div>
      )}
      {window.location.hash === '#error' && (
        <div id="error">
          <p>An error occured while submitting the form.</p>
        </div>
      )}
    </div>
  </form>
);

export default ContactForm;
